
// Helper function to determine if the code is running in a production build
export const isProductionBuild = (): boolean => {
  return window.location.hostname.includes('lovable.app') || 
         window.location.hostname.includes('helloml.co');
};

// Helper to determine if content is a Vite asset reference
export const isViteAssetReference = (content: string | null): boolean => {
  if (!content) return false;
  
  // Check for Vite export default format
  if (content.includes('export default') && content.includes('/assets/')) {
    return true;
  }
  
  // Check for direct asset path reference
  if (content.match(/\/assets\/[\w-]+\.html/)) {
    return true;
  }
  
  return false;
};

// Helper to determine if we should bypass content processing
export const shouldBypassContentProcessing = (): boolean => {
  // Check if we're on homepage
  const isHomepage = window.location.pathname === '/' || window.location.pathname === '';
  
  // Check if there's a flag in sessionStorage
  const homepageFlag = sessionStorage.getItem('isHomepage') === 'true';
  
  return isHomepage || homepageFlag;
};

// Helper function to extract asset path from Vite reference
export const extractAssetPathFromViteReference = (content: string): string | null => {
  if (!content) return null;
  
  // Extract the asset path from Vite export default
  const match = content.match(/export default ["']([^"']+)["']/);
  if (match && match[1]) {
    return match[1];
  }
  
  return null;
};

// Special homepage content cleanup for production
export const cleanupHomePageContent = (content: string | null): string => {
  if (!content) return '';
  
  // If it's a Vite reference on homepage, return empty content
  if (isViteAssetReference(content)) {
    console.log("Detected Vite reference on homepage, returning empty content");
    return '';
  }
  
  return content;
};
